import React from 'react'
import PropTypes from 'prop-types'
import { Box, Grid } from '@chatterbug/aaron'

const HeroCardSkeleton = ({
  imageSection,
  infoSection,
  infoFooterSection,
  referenceSection,
}) => {
  return (
    <Grid
      gridGap="4x"
      gridTemplateColumns={{ _: '1fr', tablet: '302px 1fr' }}
      backgroundColor="white100"
      borderRadius="1x"
      boxShadow="raised"
      p="3x"
      pb={referenceSection ? '1x' : '3x'}
    >
      {imageSection}
      <Box>
        {infoSection}
        {infoFooterSection && <Box mt="3x">{infoFooterSection}</Box>}
      </Box>
      {referenceSection && (
        <Box
          borderTopStyle="solid"
          borderTopWidth="1px"
          borderTopColor="gray88"
          sx={{
            gridColumn: '1 / -1',
          }}
        >
          {referenceSection}
        </Box>
      )}
    </Grid>
  )
}

HeroCardSkeleton.propTypes = {
  imageSection: PropTypes.any,
  infoSection: PropTypes.any,
  infoFooterSection: PropTypes.any,
  referenceSection: PropTypes.any,
}

export default HeroCardSkeleton
